import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["questions", "questionTemplate", "optionTemplate"]

  connect() {
    this.questionIndex = this.computeNextQuestionIndex()
  }

  addQuestion() {
    const html = this.questionTemplateTarget.innerHTML
      .replaceAll("__Q_INDEX__", String(this.questionIndex))
      .replaceAll("__O_INDEX__", "0")

    this.questionsTarget.insertAdjacentHTML("beforeend", html)
    const inserted = this.questionsTarget.lastElementChild
    const positionInput = inserted?.querySelector('input[name*="[position]"]')
    if (positionInput && !positionInput.value) {
      positionInput.value = String(this.questionIndex + 1)
    }
    this.questionIndex += 1
  }

  removeQuestion(event) {
    const card = event.currentTarget.closest("[data-question-card]")
    this.markForDestroyOrRemove(card)
  }

  addOption(event) {
    const questionIndex = event.params.questionIndex
    const optionsContainer = this.element.querySelector(`[data-options-container=\"${questionIndex}\"]`)
    const nextOptionIndex = Number(optionsContainer.dataset.nextOptionIndex || "0")

    const html = this.optionTemplateTarget.innerHTML
      .replaceAll("__Q_INDEX__", String(questionIndex))
      .replaceAll("__O_INDEX__", String(nextOptionIndex))

    optionsContainer.insertAdjacentHTML("beforeend", html)
    optionsContainer.dataset.nextOptionIndex = String(nextOptionIndex + 1)
  }

  removeOption(event) {
    const row = event.currentTarget.closest("[data-option-row]")
    this.markForDestroyOrRemove(row)
  }

  markForDestroyOrRemove(node) {
    const destroyInput = node.querySelector("input[data-destroy-flag]")
    if (destroyInput) {
      destroyInput.value = "1"
      node.classList.add("hidden")
      return
    }

    node.remove()
  }

  computeNextQuestionIndex() {
    const indices = Array.from(this.element.querySelectorAll("[data-question-index]"))
      .map((node) => Number(node.dataset.questionIndex))
      .filter((value) => !Number.isNaN(value))

    return indices.length === 0 ? 0 : Math.max(...indices) + 1
  }
}
